(() => {
  function init() {
    const units = document.querySelectorAll('ins[data-hf-ad-unit]');
    function requestAd(unit) {
      if (!unit.offsetWidth || unit.dataset.hfRequested || unit.hasAttribute('data-adsbygoogle-status')) return;
      unit.dataset.hfRequested = 'true';
      try { (window.adsbygoogle = window.adsbygoogle || []).push({}); }
      catch (error) { unit.dataset.hfRequested = 'failed'; }
    }
    units.forEach(unit => {
      const observer = new MutationObserver(() => {
        if (unit.getAttribute('data-ad-status') === 'unfilled') {
          unit.closest('.hf-ad-slot').dataset.hfUnfilled = 'true';
          observer.disconnect();
        }
      });
      observer.observe(unit, { attributes: true, attributeFilter: ['data-ad-status'] });
    });
    if (!('IntersectionObserver' in window)) { units.forEach(requestAd); return; }
    const visibility = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target.offsetWidth) {
          requestAd(entry.target);
          visibility.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });
    units.forEach(unit => visibility.observe(unit));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();